<template>
    <section class="container">
      <div class="d-flex justify-content-end mt-3"  >
        <div class="dropdown">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButtonPhone"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ $i18n.locale.toUpperCase() }}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonPhone">
              <a class="dropdown-item"
                 href="#"
                 @click.prevent="$parent.setLocaleLanguage('en')">EN</a>
              <a class="dropdown-item"
                 href="#"
                 @click.prevent="$parent.setLocaleLanguage('th')">TH</a>
            </div>
        </div>
      </div>
      <form class="mt-3" @submit.prevent="submitGiftForm()" data-vv-scope="gift-form" >
          <div class="form-row">
              <div class="form-group col-md-6">
                  <label for="inputName"><span class="text-danger">*</span>{{ $i18n.t('message.shipping_address.full_name')
                  }}</label>
                  <input type="text" class="form-control" id="inputName" placeholder="" v-model="giftForm.name" required>
              </div>
              <div class="form-group col-md-6">
                  <label for="inputTel"><span class="text-danger">*</span>{{ $i18n.t('message.shipping_address.tel')
                  }}</label>
                  <input type="tel" class="form-control" id="inputTel" placeholder="" v-model="giftForm.tel" required>
              </div>
          </div>
          <div class="form-row">
              <div class="form-group col-md-12">
                  <label for="inputTypeBuilding"><span class="text-danger">*</span>{{ $i18n.t('message.shipping_address.address')
                  }}</label>
                  <div>
                      <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="inlineRadioBuildingType" id="inlineRadioBuildingType1" :value="1" v-model="giftForm.building_type">
                      <label class="form-check-label" for="inlineRadioBuildingType1">{{ $i18n.t('message.shipping_address.type_address_home')
                      }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="inlineRadioBuildingType" id="inlineRadioBuildingType2" :value="2" v-model="giftForm.building_type">
                          <label class="form-check-label" for="inlineRadioBuildingType2">{{ $i18n.t('message.shipping_address.type_address_condo')
                          }}</label>
                      </div>
                  </div>
              </div>
          </div>
          <div class="form-row">
              <div class="form-group col-md-6" v-if="isCondo()" >
                  <label for="inputVillage"><span class="text-danger" v-if="isCondo()">*</span>{{ $i18n.t('message.shipping_address.village')
                  }}</label>
                  <input type="text" class="form-control" id="inputVillage" placeholder="" v-model="giftForm.village" :required="isCondo()">
              </div>
              <div class="form-group col-6 col-md-6" v-if="isCondo()" >
                  <label for="inputRoomNo">{{ $i18n.t('message.shipping_address.room_no')
                  }}</label>
                  <input type="text" class="form-control" id="inputRoomNo" placeholder="" v-model="giftForm.room_no">
              </div>
              <div class="form-group col-md-6" :class="isCondo() ? 'col-6':''" >
                  <label  for="inputHouseNo"><span class="text-danger" v-if="!isCondo()">*</span>{{ $i18n.t('message.shipping_address.house_no')
                  }}</label>
                  <input type="text" class="form-control" id="inputVillageNo" placeholder="" v-model="giftForm.house_no" :required="!isCondo()" >
              </div>
              <div class="form-group col-md-6">
                  <label for="inputVillageNo">{{ $i18n.t('message.shipping_address.village_no')
                  }}</label>
                  <input type="text" class="form-control" id="inputHouseNo" placeholder="" v-model="giftForm.village_no">
              </div>
              <div class="form-group col-6 col-md-6">
                  <label for="inputSoi">{{ $i18n.t('message.shipping_address.soi')
                  }}</label>
                  <input type="text" class="form-control" id="inputSoi" placeholder="" v-model="giftForm.soi">
              </div>
              <div class="form-group col-6 col-md-6">
                  <label for="inputRoad"><span class="text-danger">*</span>{{ $i18n.t('message.shipping_address.road')
                  }}</label>
                  <input type="text" class="form-control" id="inputSoi" placeholder="" v-model="giftForm.road" required>
              </div>
              <div class="form-group col-6 col-md-6">
                  <label for="inputAddressProvince"><span class="text-danger">*</span>{{ $i18n.t('message.shipping_address.province')
                  }}</label>
                  <div>
                      <select class="form-control" v-model="giftForm.address_province_id" id="inputAddressProvince" required>
                          <option :value="null"></option>
                          <option :value="addressProvince.id" v-for="addressProvince, index in sortedProvinces">
                          {{ addressProvince | multiLangName }}
                          </option>
                      </select>
                  </div>
              </div>
              <div class="form-group col-6 col-md-6">
                  <label for="inputDistrict"><span class="text-danger">*</span>{{ $i18n.t('message.shipping_address.district')
                  }}</label>
                  <div>
                      <select class="form-control" v-model="giftForm.district_id" id="inputDistrict" required>
                        <option :value="null"></option>
                        <option :value="district.id" v-for="district, index in sortedDistricts">
                            {{ district | multiLangName }}
                        </option>
                      </select>
                  </div>
              </div>
              <div class="form-group col-6 col-md-6">
                  <label for="inputSubDistrict"><span class="text-danger">*</span>{{ $i18n.t('message.shipping_address.sub_district')
                  }}</label>
                  <div>
                      <select class="form-control" v-model="giftForm.sub_district_id" id="inputSubDistrict" required>
                          <option :value="null"></option>
                          <option :value="subDistrcict.id" v-for="subDistrcict, index in sortedSubDistricts">
                              {{ subDistrcict | multiLangName }}
                          </option>
                      </select>
                  </div>
              </div>
              <div class="form-group col-6 col-md-6">
                  <label for="inputZipcode"><span class="text-danger">*</span>{{ $i18n.t('message.shipping_address.zip_code')
                  }}</label>
                  <input type="number" class="form-control" id="inputZipcode" placeholder="00000" v-model="giftForm.zip_code">
              </div>

          </div>
          <button type="submit" class="btn btn-success btn-block my-2" :disabled="submited" > {{ submited ? $i18n.t('message.shipping_address.submited')
           : editedState ? $i18n.t('message.shipping_address.edited'): $i18n.t('message.shipping_address.save')}} 
          </button>
      </form>
    </section>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
export default {
  data: () => ({
    giftForm: {
      name: '',
      tel: null,
      building_type: 1,
      village: null,
      room_no: null,
      village_no: null,
      house_no: null,
      soi: null,
      road: null,
      sub_district_id: null,
      district_id: null,
      address_province_id: null,
      zip_code: null,
      user_id: null
    },
    submited: false,
    editedState: false
  }),
  computed: {
    ...mapGetters({
      globalState: 'globalVal/getState',
      user: 'auth/getUser'
    }),
    ...mapState('chatBooking', ['messages', 'bookingData']),
    ...mapState('addressProvince', ['addressProvinces', 'districts', 'subDistricts']),
    sortedProvinces () {
      return this._.orderBy(this.addressProvinces, [this.sortBy], ['asc'])
    },
    sortedDistricts () {
      return this._.orderBy(this.districts, [this.sortBy], ['asc'])
    },
    sortedSubDistricts () {
      return this._.orderBy(this.subDistricts, [this.sortBy], ['asc'])
    },
    flagImage () {
      return (this.$i18n.locale === 'en') ? '/static/img/flag-en.jpg' : '/static/img/flag-th.jpg'
    }
  },
  watch: {
    'giftForm.address_province_id': function (newVal, oldVal) {
      if (newVal) {
        this.fetchDistricts(this.giftForm.address_province_id)
      } else {
        this.districts = null
        this.subDistricts = null
      }
    },
    'giftForm.district_id': function (newVal, oldVal) {
      if (newVal) {
        this.fetchSubDistricts(this.giftForm.district_id)
      } else {
        this.subDistricts = null
      }
    },
    'giftForm.sub_district_id': function (newVal, oldVal) {
      if (newVal) {
        let data = this.sortedSubDistricts.filter((item) => item.id === this.giftForm.sub_district_id)
        if (data.length) {
          this.giftForm.zip_code = data[0].zip_code
        }
      } else {
        this.giftForm.zip_code = null
      }
    },
    'giftForm.tel': function (newVal, oldVal) {
      let inputTel = document.getElementById('inputTel')
      inputTel.classList.remove('is-invalid')
    },
    user (n, o) {
      if (n) {
        this.setFormEdited(n.id)
      }
    }
  },
  methods: {
    isCondo () {
      return this.giftForm.building_type === 2
    },
    fetchAddressProvinces () {
      this.$store.dispatch('addressProvince/LOAD_ADDRESS_PROVINCES')
    },
    fetchDistricts (provinceId) {
      if (provinceId) {
        const queryData = {
          province_id: provinceId
        }
        this.$store.dispatch('addressProvince/LOAD_DISTRICTS', queryData)
      }
    },
    fetchSubDistricts (districtId) {
      if (districtId) {
        const queryData = {
          district_id: districtId
        }
        this.$store.dispatch('addressProvince/LOAD_SUB_DISTRICTS', queryData)
      }
    },
    checkLogin () {
      if (('isLoggingIn' in window.localStorage && window.localStorage.getItem('isLoggingIn') === 'false')) {
        if (this.user === null) {
          this.$parent.openModal('login')
        }
      } else {
        this.$parent.openModal('login')
      }
    },
    async validateUser (userId, validation) {
      // เช็ค validation จาก hash
      try {
        const { data } = await axios.get('/users/validate', {params: {user_id: userId, validation: validation}})
        if (!data.error) {
          this.giftForm.user_id = userId
          await this.setFormEdited(userId)
        } else {
          this.checkLogin()
          // this.$swal('Error', 'กรุณาล็อกอินใหม่', 'error')
        }
      } catch (e) {
        this.checkLogin()
        // this.$swal('Error', 'กรุณาล็อกอินใหม่', 'error')
      }
    },
    submitGiftForm () {
      let rex = /^\+?[0-9-]+$/
      let phone = this.giftForm.tel
      let phoneValid = phone.match(rex)
      let inputTel = document.getElementById('inputTel')
      if (!phoneValid || !(phone.length >= 10 && phone.length <= 15)) {
        inputTel.classList.add('is-invalid')
        return
      }
      this.$validator.validateAll('gift-form').then(async (valid) => {
        if (valid) {
          this.submited = true
          this.saveGiftForm()
        }
      })
    },
    async saveGiftForm () {
      let params = {...this.giftForm}
      if (this.user) {
        params.user_id = params.user_id ? params.user_id : this.user.id
      }
      if (params.user_id) {
        try {
          let url = '/users/shipping-address'
          let method = 'post'
          if (this.editedState) {
            // แก้ไข
            url = `/users/${params.id}/shipping-address`
            method = 'put'
          }
          const { data } = await axios[method](url, params)
          if (!data.error) {
            this.setFormEdited(params.user_id)
            this.$swal('บันทึกเรียบร้อย', '', 'success')
          } else {
            this.$swal('Error', data.message, 'error')
          }
        } catch (error) {
          this.$swal('Error', error.message, 'error')
        }
      } else {
        this.checkLogin()
      }
      this.submited = false
    },
    async setFormEdited (userId) {
      try {
        const { data } = await axios.get(`/users/${userId}/shipping-address`)
        if (!data.error) {
          if (data.gift_form) {
            this.giftForm = {...data.gift_form}
            this.editedState = true
          }
        }
      } catch (e) {
        console.log(e.message)
      }
    }
  },
  mounted () {
    this.fetchAddressProvinces()

    const { query } = this.$route
    if (query.user_id && query.validation) {
      const { user_id: userId, validation } = query
      this.validateUser(userId, validation)
    } else {
      this.user ? this.setFormEdited(this.user.id) : this.checkLogin()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/ShippingAddress.vue